import React from 'react';
import hoc from './FieldHOC';
import HelpText from './HelpText';

class RadioBox extends React.Component{

  constructor(props) {
    super(...arguments);
    this.state = RadioBox.getDerivedStateFromProps(props);
  }

  static getDerivedStateFromProps(props){
    let selectedField = props.field.get('options').findWhere({selected: "1"});
    if (typeof selectedField === 'undefined') {
      selectedField = props.field.get('options').findWhere({selected: 1});
    }
    if (props.value) {
      selectedField = props.field.get('options').get(props.value);
    }
    let selectedValue = selectedField ? selectedField.getCurrencyValue() : 0;
    props.field.setSelectedValue(selectedValue);
    return {
      value: selectedField
    };
  }

  onChange(option){
    this.props.field.setSelectedValue(option.getCurrencyValue());
    this.setState({
      value: option
    });
    this.props.onChange(option);
  }

  render(){
    let field = this.props.field;
    let o = field.get('options').map((option) => {
      const checked = this.state.value ? this.state.value.get('id') === option.get('id') : undefined;
      const title = this.props.language === 'french' && option.get('name_french') ? option.get('name_french') : option.get('name');
      return <div key={`field-option-${option.get('name')}`} className="radio">
        <label>
          <input aria-label={this.props.title || field.get('title')} type="radio" name={this.props.name} disabled={this.props.disabled} checked={checked} value={option.get('id')} tabIndex={this.props.tabIndex} onChange={this.onChange.bind(this, option)} /> {title}
        </label>
      </div>;
    });
    return (
      <div>
        <label htmlFor={this.props.name}>{this.props.title || field.get('title')}</label>
        <HelpText field={field} helpText={this.props.helpText} />
        {this.props.errorComponent}
        {o}
      </div>
    );
  }

}

export default hoc(RadioBox);
